"use strict";

(function () {
  'use strict';

  angular.module('lr.Settings').factory('AccountSetttingsService', AccountSetttingsService);
  AccountSetttingsService.$inject = ['$http', '$q', 'api'];
  /* @ngInject */

  function AccountSetttingsService($http, $q, api) {
    var getAccountSettings = function getAccountSettings() {
      var deferred = $q.defer();
      $http.get(api.proxy + '/settings/account').then(function (data, status) {
        if (status === 200 || data.status === 200) {
          deferred.resolve(data);
        } else {
          deferred.reject(data);
        }
      }, function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    };

    var updateAccountSettings = function updateAccountSettings(settings) {
      var deferred = $q.defer();
      $http.put(api.proxy + '/settings/account', settings).then(function (data, status) {
        if (status === 200 || data.status === 200) {
          deferred.resolve(data);
        } else {
          deferred.reject(data);
        }
      }, function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    };

    return {
      getAccountSettings: getAccountSettings,
      updateAccountSettings: updateAccountSettings
    };
  }
})();